import { createDispatchHook, createSelectorHook, TypedUseSelectorHook } from 'react-redux';
import { AppDispatchTS, ContextStoreTS, RootStateTS } from './storeTS';

export const useAppDispatchTS: () => AppDispatchTS = createDispatchHook(ContextStoreTS)
export const useAppSelectorTs: TypedUseSelectorHook<RootStateTS> = createSelectorHook(ContextStoreTS)